/* Nida Home - barre "Ajouter au panier" collante (mobile).
   Reutilise toujours le formulaire produit Dawn actif afin de conserver
   les variantes et les proprietes de personnalisation cadeau. */
(function () {
  var stickyId = 'nida-sticky-atc';
  var cookieSelector = '#shopify-pc__banner';
  var buttonSelector = '.product-form__submit, product-form button[name="add"], product-form [name="add"]';
  var priceSelector = '.product__info-wrapper .price-item--sale:not(.hidden), .product__info-wrapper .price-item--regular, .product__info-wrapper .price-item';
  var cookieResizeObserver;
  var observedCookieBanner;
  var buttonIntersectionObserver;
  var observedRealButton;
  var updateQueued = false;

  function normalizeCookiePreferencesLink() {
    var links = document.querySelectorAll('a[href$="#shopifyReshowConsentBanner"]');
    links.forEach(function (link) {
      link.setAttribute('href', '#shopifyReshowConsentBanner');
    });
  }

  function findRealButton() {
    return document.querySelector(buttonSelector);
  }

  function findProductForm(realButton) {
    return realButton ? realButton.closest('form') : document.querySelector('product-form form');
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.height > 0 && rect.width > 0;
  }

  function measureCookieBanner(bar) {
    var banner = document.querySelector(cookieSelector);
    var bannerVisible = isVisible(banner);
    var offset = bannerVisible ? Math.ceil(banner.getBoundingClientRect().height) : 0;

    document.documentElement.style.setProperty('--nida-cookie-banner-offset', offset + 'px');
    bar.classList.toggle('has-cookie-banner', bannerVisible);

    if ('ResizeObserver' in window && banner !== observedCookieBanner) {
      if (cookieResizeObserver) cookieResizeObserver.disconnect();
      observedCookieBanner = banner;
      if (banner) {
        cookieResizeObserver = new ResizeObserver(function () {
          queueUpdate(bar);
        });
        cookieResizeObserver.observe(banner);
      }
    }
  }

  function observeRealButton(bar, realButton) {
    if (!('IntersectionObserver' in window) || realButton === observedRealButton) return;
    if (buttonIntersectionObserver) buttonIntersectionObserver.disconnect();
    observedRealButton = realButton;
    if (!realButton) return;

    buttonIntersectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-hidden', entry.isIntersecting);
      });
    }, { threshold: 0 });
    buttonIntersectionObserver.observe(realButton);
  }

  function syncProductState(bar) {
    var realButton = findRealButton();
    var priceElement = document.querySelector(priceSelector);
    var stickyPrice = bar.querySelector('.nida-sticky-atc__price');
    var stickyButton = bar.querySelector('.nida-sticky-atc__btn');
    var stickyInstallment = bar.querySelector('.nida-sticky-atc__installment');

    if (priceElement && stickyPrice) {
      var price = priceElement.textContent.trim();
      if (stickyPrice.textContent !== price) stickyPrice.textContent = price;
      if (stickyInstallment) {
        var installment = installmentPrice(price);
        if (installment && stickyInstallment.textContent !== installment) stickyInstallment.textContent = installment;
      }
    }
    if (realButton && stickyButton) {
      var realLabel = realButton.querySelector('span') || realButton;
      var label = realLabel.textContent.trim();
      var disabled = Boolean(realButton.disabled);
      var ariaDisabled = disabled ? 'true' : 'false';
      if (label && stickyButton.textContent !== label) stickyButton.textContent = label;
      if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
      if (stickyButton.getAttribute('aria-disabled') !== ariaDisabled) {
        stickyButton.setAttribute('aria-disabled', ariaDisabled);
      }
    }

    observeRealButton(bar, realButton);
    measureCookieBanner(bar);
  }

  function queueUpdate(bar) {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(function () {
      updateQueued = false;
      syncProductState(bar);
    });
  }

  function paymentCopy() {
    var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    if (lang === 'en') return { prefix: 'or 4×', suffix: 'interest-free', provider: 'with' };
    if (lang === 'de') return { prefix: 'oder 4×', suffix: 'zinsfrei', provider: 'mit' };
    if (lang === 'tr') return { prefix: 'veya 4×', suffix: 'faizsiz', provider: 'PayPal ile' };
    if (lang === 'ar') return { prefix: 'أو 4 دفعات', suffix: 'بلا فوائد', provider: 'مع' };
    return { prefix: 'ou 4×', suffix: 'sans frais', provider: 'avec' };
  }

  function installmentPrice(priceText) {
    var compact = priceText.replace(/\s/g, '');
    var numberText = compact.replace(/[^0-9,.-]/g, '');
    if (numberText.lastIndexOf(',') > numberText.lastIndexOf('.')) {
      numberText = numberText.replace(/\./g, '').replace(',', '.');
    } else {
      numberText = numberText.replace(/,/g, '');
    }
    var value = Number(numberText);
    if (!Number.isFinite(value)) return '';

    var lang = document.documentElement.lang || 'fr-FR';
    var amount = (value / 4).toLocaleString(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var currency = priceText.replace(/[0-9.,\s]/g, '').trim() || '€';
    return amount + ' ' + currency;
  }

  function init() {
    normalizeCookiePreferencesLink();

    var realButton = findRealButton();
    var form = findProductForm(realButton);
    if (!realButton && !form) return;
    if (document.getElementById(stickyId)) return;

    var paypalLogo = document.querySelector('.nida-paypal-wordmark__logo');
    var paypalMarkup = paypalLogo
      ? paypalLogo.outerHTML
      : '<span class="nida-sticky-atc__paypal-text">PayPal</span>';
    var copy = paymentCopy();

    var bar = document.createElement('div');
    bar.id = stickyId;
    bar.innerHTML =
      '<div class="nida-sticky-atc__inner">' +
        '<span class="nida-sticky-atc__pricewrap">' +
          '<span class="nida-sticky-atc__price"></span>' +
          '<span class="nida-sticky-atc__deal">' +
            '<span class="nida-sticky-atc__deal-main">' + copy.prefix + ' <span class="nida-sticky-atc__installment"></span> ' + copy.suffix + '</span>' +
            '<span class="nida-sticky-atc__provider">' + copy.provider + ' ' + paypalMarkup + '</span>' +
          '</span>' +
        '</span>' +
        '<button type="button" class="nida-sticky-atc__btn"></button>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.nida-sticky-atc__btn').addEventListener('click', function () {
      var currentButton = findRealButton();
      var currentForm = findProductForm(currentButton);
      if (currentButton && !currentButton.disabled) currentButton.click();
      else if (currentForm && currentForm.requestSubmit) currentForm.requestSubmit();
      else if (currentForm) currentForm.submit();
    });

    var pageObserver = new MutationObserver(function () {
      queueUpdate(bar);
    });
    pageObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'disabled', 'aria-hidden']
    });

    window.addEventListener('resize', function () { queueUpdate(bar); }, { passive: true });
    window.addEventListener('orientationchange', function () { queueUpdate(bar); }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () { queueUpdate(bar); }, { passive: true });
    }

    syncProductState(bar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
